<div class="">
   <div style="height: auto;" class="grid">
      <div class="col-6 md:col-4">
        <span class="p-float-label">
          <p-multiSelect
            id="container-filter"
            [options]="containerFilter"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            [showClear]="false"
            [(ngModel)]="containerValue"
            (onChange)="applyFiler()"
            class="custom-multiselect bg-form"
          />
          <label for="container-filter" style="font-size: 0.8rem;">
            {{'UserPages.UserLoadMasterOrders.filters.containerFilter' | translate}}
          </label>
        </span>
      </div>
      <div class="col-6 md:col-4">
        <span class="p-float-label">
          <p-multiSelect
            id="specie-filter"
            [options]="specieFilter"
            [showClear]="false"
            [filter]="true"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="specieValue"
            (onChange)="applyFiler()"
            class="custom-multiselect bg-form"

          />
          <label for="specie-filter" style="font-size: 0.8rem;">
            {{'UserPages.UserLoadMasterOrders.filters.specieFilter' | translate}}
          </label>
        </span>
      </div>
      <div class="col-6 md:col-4">
        <span class="p-float-label">
          <p-multiSelect
            id="variety-filter"
            [options]="varietyFilter"
            [showClear]="false"
            [filter]="true"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="varietyValue"
            (onChange)="applyFiler()"
            class="custom-multiselect bg-form"
          />
          <label for="variety-filter" style="font-size: 0.8rem;">
            {{'UserPages.UserLoadMasterOrders.filters.varietyFilter' | translate}}
          </label>
        </span>
      </div>
      <div class="col-6 md:col-4">
        <span class="p-float-label">
          <p-multiSelect
            id="producer-filter"
            [options]="producerFilter"
            [filter]="true"
            [showClear]="false"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="producerValue"
            (onChange)="applyFiler()"
            class="custom-multiselect bg-form"
          />
          <label for="producer-filter" style="font-size: 0.8rem;">
            {{'UserPages.UserLoadMasterOrders.filters.ProducerFilter' | translate}}
          </label>
        </span>
      </div>
      <div class="col-6 md:col-4">
        <span class="p-float-label">
          <p-multiSelect
            id="pallet-filter"
            [options]="speciesSizeFilter"
            [filter]="true"
            optionLabel="label"
            optionValue="value"
            [showClear]="false"
            [(ngModel)]="speciesSizeValue"
            (onChange)="applyFiler()"
            class="custom-multiselect bg-form"
          />
          <label for="container-filter" style="font-size: 0.8rem;">
            {{'UserPages.UserLoadMasterOrders.filters.SpeciesSize' | translate}}
          </label>
        </span>
      </div>
      <div class="col-6 md:col-4">
        <span class="p-float-label">
          <p-multiSelect
            id="program-name-filter"
            [options]="programNameFilter"
            [showClear]="false"
            [filter]="true"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="programNameValue"
            (onChange)="applyFiler()"
            class="custom-multiselect bg-form"
          />
          <label for="status-filter" style="font-size: 0.8rem;">
            {{'UserPalletStock.ProgramName' | translate}}
          </label>
        </span>
      </div>
      <div class="col-6 md:col-4">
        <span class="p-float-label">
          <p-multiSelect
            id="status-filter"
            [options]="statusFilter"
            [showClear]="false"
            [filter]="true"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="statusValue"
            (onChange)="applyFiler()"
            class="custom-multiselect bg-form"
          />
          <label for="status-filter" style="font-size: 0.8rem;">
            {{'UserPalletStock.StatusLabel' | translate}}
          </label>
        </span>
      </div>
   </div>
</div>
